import { CSSObject } from '@chakra-ui/react';

export const betslipFooterStyles = {
  iconClearBet: {},
};

export const FlexResponsibleGamblingBannerWrapper: CSSObject = {
  pt: '0',
};
